import PrimaryButton from "./primary-button";

const CASH_BACK_NOTICE = {
  title: "Your Cash Back is sent after your property pays.",
  timing:
    "It is important to understand that Cash Back processing time depends primarily on the property where you leased. Upon move-in, we will send our referral invoice to your property. Only after this referral invoice has been paid can we process a customer’s Cash Back. This process typically takes between 8 and 16 weeks, but can take longer depending on the property’s invoice processing time.",
  update: "For an update on the status of your Cash Back, you may:",
  contactLabel: "Contact a Cash Back Coordinator",
  terms: [
    "Stake.rent's Cash Back offer is subject to all qualifications and conditions outlined on our Disclaimers and Terms of Service page. Cash Back will only be sent after your apartment community has paid Stake.rent's referral invoice. Cash Back is typically mailed within 8 to 16 weeks after you move in, but can take longer depending on your property's invoice processing time.",
    "All Cash Back customers must complete our Online Cash Back Request in order to qualify. Cash Back requests must be submitted within 60 days of lease start date. Cash Back will be paid via check and mailed to the address you provide during our Online Cash Back Request process.",
    "In the event a Cash Back check is lost or stolen, you may request a replacement check by contacting our Cash Back Department within 60 days of check issuance date. Cash Back checks become void 60 days after date of issuance.",
  ],
};

export default function CashBackDisclaimerScreen({ onBack, onContinue, onContact }) {
  return (
    <section className="ir-sheet">
      <div className="ir-sheet-top">
        <button className="ir-icon-btn is-ghost" type="button" aria-label="Go back" onClick={onBack}>
          <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M10 3.5 5.5 8 10 12.5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
      <div className="ir-sheet-body">
        <div>
          <h1>{CASH_BACK_NOTICE.title}</h1>
          <p className="ir-sheet-lead">{CASH_BACK_NOTICE.timing}</p>
        </div>
        <div className="ir-cashback-notice">
          <p>
            {CASH_BACK_NOTICE.update}{" "}
            <button type="button" onClick={onContact}>
              {CASH_BACK_NOTICE.contactLabel}
            </button>
          </p>
          <div className="ir-cashback-terms">
            {CASH_BACK_NOTICE.terms.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </div>
      </div>
      <div className="ir-sheet-footer">
        <PrimaryButton onClick={onContinue}>Continue</PrimaryButton>
      </div>
    </section>
  );
}
